// extracted by mini-css-extract-plugin
export default {"box":"emptyevent_box__EL94v","heading":"emptyevent_heading__nhAQN","text":"emptyevent_text__0HO-Y"};